import { render, staticRenderFns } from "./OwnerForm.vue?vue&type=template&id=064e6c5a&scoped=true&"
import script from "./OwnerForm.vue?vue&type=script&lang=js&"
export * from "./OwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerForm.vue?vue&type=style&index=0&id=064e6c5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e6c5a",
  null
  
)

export default component.exports